<template>
  <div class="bodyTable">
    <v-form ref="form" v-model="formFieldsValid" lazy-validation>
      <v-data-table
        v-model="selected"
        color="blue lighten-4"
        item-key="codiceRiga"
        :headers="headers"
        :items="righeDocumento"
        :item-class="itemBackground"
        :options.sync="options"
        :server-items-length="totaleRighe"
        :loading="loading"
        class="elevation-1"
        @click:row="clickRow"
        @dblclick:row="dblclickRow"
        :disable-sort="true"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 15, 50, 100]
        }"
        dense
        calculate-widths
        :single-expand="singleExpand"
        :expanded.sync="expanded"        
      > 
        <template v-slot:[`item.rigaDescrittiva`]="{ item, index }">
          <component :is="'pSwitch'" :item="itemRigaDescrittiva(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="disableRigaDescrittiva(item)" :updateTrigger="updateTrigger"/>
        </template>      
        <template v-slot:[`item.codice`]="{ item, index }">
          <component :is="'pProdotto'"  v-if="!item.rigaDescrittiva" :item="itemCodice(item)"
            :index="index" :appoggio="item.appoggio" :disabled="readOnly"
            :updateTrigger="updateTrigger" :suTable="true" :refreshSource="refreshSource" :refreshSourceCode="refreshSourceCode"
            :forzaAggiornamento="forzaAggiornamento" :abilitaRicercaInterna="abilitaRicercaInterna"
            @change="componentValueChange"/>
        </template>       
        <template v-slot:[`item.descrizione`]="{ item, index }">
          {{ (item.rigaIndentata ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : '') }}<component :is="'pTesto'" :item="itemDescrizione(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
        </template>
        <template v-slot:[`item.quantita`]="{ item, index }">
          <component :is="'pTesto'" :item="itemQuantita(item)" :ref="`quantita_${index}`" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly || item.usaScalaTaglie" :updateTrigger="updateTrigger" :suTable="true"/>
        </template>
        <template v-slot:[`item.unitaMisura`]="{ item, index }">
          <component :is="'pMultiselect'" :item="itemUnitaMisura(item)" :index="index" :disableClear="true" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
        </template>
        <template v-slot:[`item.aliquota`]="{ item, index }">
          <component :is="'pMultiselect'" :item="itemAliquota(item)" :index="index" :disableClear="true" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
          <!-- <v-text-field v-else dense hide-details="auto" solo flat :value="itemAliquota(item, true)" @click="re(index)"/> -->
        </template>        
        <template v-slot:[`item.appoggio.prodotto.acquistoFornitore`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getUltimoAcquisto(item, true) | euro"/>
        </template>
        <template v-slot:[`item.appoggio.prodotto.acquisto`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" class="text-caption" readonly :value="getUltimoAcquisto(item, false)"/>
        </template>        
        <template v-slot:[`item.appoggio.importoTotale`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getImportoTotale(item) | euro"/>
        </template>
        <template v-slot:[`item.giacenza`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getGiacenza(item)"/>
        </template>
        <template v-slot:[`item.omaggio`]="{ item, index }">
          <component v-if="!item.rigaDescrittiva" :is="'pSwitch'" :item="itemOmaggio(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/>
        </template> 
        <template v-slot:[`item.actions`]="{ item, index }">
          <v-icon small @click="deleteItem(item)" title="Cancella la riga">mdi-delete</v-icon>
          <v-menu :offset-x="true" left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-3" v-bind="attrs" v-on="on" title="Azioni aggiuntive">mdi-dots-vertical</v-icon>
            </template>
            <three-dots-menu :item="item" :index="index" :rowsNumber="righeDocumento.length" @click="menuClick"/>
          </v-menu>    
        </template>
<!--         <template v-slot:[`foot`]>
          <v-btn class="text-right" @click="onNuovaRiga" v-if="nuovaRigaAbilitata">Nuova riga</v-btn>
        </template> -->
        <template v-slot:[`body.append`]>
            <td :colspan="4">
              <v-btn class="text-right mr-5 mt-2 mb-2" :disabled="readOnly" @click="onNuovaRiga" v-if="nuovaRigaAbilitata">Nuova riga</v-btn>
              <v-btn class="text-right  mt-2 mb-2" :disabled="readOnly" @click="onNuovaRigaST" v-if="nuovaRigaAbilitata && nuovaRigaAbilitataST" color="blue-grey lighten-4">Nuova riga Scala Taglie</v-btn>
            </td>
        </template>        
        <template v-slot:[`footer.prepend`]>
          <v-btn color="success" @click="onMostraParcheggio" v-if="nuovaRigaAbilitata">Importa da Park</v-btn>
          <h3 v-else class="red--text">E' necessario selezionare un fornitore per poter aggiungere i prodotti</h3>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="articoliSelected">
            <dettaglio-scala tipoInput="quantita" :coloreSuRighe="coloreSuRighe" :codiceProdotto="item.codice" :scalaTaglie="item.scalaTaglie" :mostraValoreUnico="true" :refresh="triggerRefresh" @change="salvaDatiST(item, $event)"></dettaglio-scala>
          </td>
        </template>
        <template v-slot:[`item.expand`]="{ item }">
          <v-btn icon @click="expanded = [item]" v-if="item.usaScalaTaglie && !expanded.includes(item)"><v-icon>mdi-chevron-down</v-icon></v-btn>
          <v-btn icon @click="expanded = []" v-if="item.usaScalaTaglie && expanded.includes(item)"><v-icon>mdi-chevron-up</v-icon></v-btn>
        </template>
      </v-data-table>
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Confermi cancellazione riga ?</v-card-title>
          <v-card-text>{{dettaglioRiga}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
            <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <dialog-storico :show="dialogStorico" :prodotto="prodottoStorico" @aggiornaPrezzo="aggiornaPrezzo"/>
    </v-form>
  </div>
</template>

<script>
  import * as dot from 'dot-object'
  import _ from 'lodash'
  import { v4 as uuidv4 } from 'uuid'
  import prodotti from '@/services/prodottiService.js'
  import magazzino from '@/services/magazzinoService.js'  
  import configurazioni from '@/services/configurazioniService.js'  
  import pProdotto from './elementi/prodotto'
  import pSwitch from './elementi/switch'
  import pTesto from './elementi/testo'
  import pMultiselect from './elementi/multiselect'
  // import pQuattroValori from './elementi/quattroValori'
  import ThreeDotsMenu from './elementiBody/threeDotsMenu'
  import DialogStorico from './elementiBody/dialogStorico'
  import DettaglioScala from '@/views/custom/scalaTaglie/elementi/dettaglioScala'

  export default {
    components: {
      pProdotto,
      pSwitch,
      pTesto,
      pMultiselect,
      ThreeDotsMenu,
      DialogStorico,
      DettaglioScala
      // pQuattroValori
    },
    props: {
      locDocumento: Object,
      trigger: { type: Number, default: 1},
      readOnly: { type: Boolean, default: false }
    },
    data () {
      return {
        selected: [],
        loading: false,
        options: {},
        headersDefault: [
          
          // https://dev.to/andynoir/draggable-table-row-with-vuejs-vuetify-and-sortablejs-1o7l

          /* { text: '', value: 'updown', sortable: false , width: '10px'}, */
          { text: 'Descrittiva', value:'rigaDescrittiva', width: '1%' }, 
          { text: 'Codice', value: 'codice', align: 'start', width: '10%'},
          { text: 'Descrizione', value: 'descrizione', width: '20%' },
          { text: 'Quantità', value: 'quantita', align: 'start', width: '5%' },
          { text: 'UM', value: 'unitaMisura', align: 'start', width: '4%' },
/*           { text: 'Listino', value: 'listino', align: 'start', width: '8%' }, */
          { text: 'Aliquota', value: 'aliquota' , align: 'start', width: '8%'},
        /*        
          { text: 'Prezzi', value: 'prezzi' , align: 'start'},
          { text: 'Sconti', value: 'sconti' , align: 'start'},
          { text: 'Importi', value: 'importi' , align: 'start'},
        */
          { text: 'Prezzo Acquisto', value: 'appoggio.prodotto.acquistoFornitore', align: 'start'},
          { text: 'Ultimo Acquisto', value: 'appoggio.prodotto.acquisto', align: 'start'},
          
/*           { text: 'Sconto', value: 'valore.prezzoNettoTotale' , align: 'start'}, */
          { text: 'Importo Totale', value: 'appoggio.importoTotale' , align: 'start'},
          { text: 'Giac.', value: 'giacenza' , align: 'start'},
/*           { text: 'Imponibile', value: 'valore.importoNettoTotale' , align: 'start'},
          { text: 'Iva', value: 'valore.prezzoNettoUnitario' , align: 'start'}, */
          { text: 'Omaggio', value: 'omaggio', align: 'start'},
          { text: 'Actions', value: 'actions', sortable: false }
        ],
        headersScalaTaglie: [
          { text: '', value: 'expand' }
        ],        
        expanded: [],
        singleExpand: false,
        dialog: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
/*         defaultItem: null,
        modelloDocumento: null, */
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        // impostazioniEtichette: null,
        usaQtaAnagrafica: false, // TODO: da configurazioni
        salta: 0,
        filtroElementi: null,
        tipoStampa: '',
        report: '',
        erroreDocumento: '',
        updateTrigger: 1,
        refreshSource: 1,
        refreshSourceCode: '',
        forzaAggiornamento: false,
        // readOnly: false, // eventualmente su computed,
        locRigaDocumento: null,
        rigaModello: {
          rigaDescrittiva: false,
          codice: '',
          descrizione: '',
          quantita: '',
          unitaMisura: '',
          listino: null,
          aliquota: null,
          prezzi: null,
          sconti: null,
          importi: null
        },
        aggiornaSconti: true, // da impostazioni scelgo se aggiornare gli sconti o il prezzo di listino nel caso di modifica dell'importo
        dialogStorico: false,
        prodottoStorico: null,
        mostraParcheggio: false,
        formFieldsValid: true,
        abilitaRicercaInterna: false, // TODO: Prendere da impostazioni/backoffice/prodotti/abilitaRicercaInterna
        numDecimali: 4,
        nuovaRigaAbilitataST: false,
        coloreSuRighe: true,
        triggerRefresh: 1        
      }
    },
    computed: {
      righeDocumento() {
        return _.get(this, 'locDocumento.righe', [])
      },
      totaleRighe() {
        return this.righeDocumento.length
      },
      nuovaRigaAbilitata() {
        return this.trigger && this.locDocumento.anagrafica
      },
      dettaglioRiga() {
        let riga = this.editedIndex
        if (riga === -1) return
        let ed = this.righeDocumento[riga]
        if (!ed) return ''
        return ed.descrizione.trim()
      },
      headers() {
        const hd = this.nuovaRigaAbilitataST ? this.headersDefault.concat(this.headersScalaTaglie) : this.headersDefault
        return hd
      }
    },
    watch: {
      options: {
        async handler () {
          // await this.getDataFromApi()
        },
        deep: true
      },
      dialog (val) {
        val || this.dialogClose()
      },     
      dialogDelete (val) {
        val || this.closeDelete()
      }
    },
    async mounted () {
      this.$root.$on('aggiungiProdotti', this.onAggiungiProdotti)

      const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.nuovaRigaAbilitataST = !!impostazioni.usaScalaTaglie      
    },
    methods: {
      itemBackground(item) {
        return item.omaggio ? 'is-omaggio' : ''
      },      
      datiCompleti() {
        const valid = this.$refs.form.validate()
        return valid // TODO: Completare verifica
      },      
      async onAggiungiProdotti(righe) {
        for (let riga of righe) {
          const idProdotto = riga.codice
          const p = await prodotti.getProdotto(idProdotto)
          let nr = JSON.parse(JSON.stringify(this.rigaModello))
          nr.valore = nr.valore || {}
          nr.valore.listino = this.locDocumento.appoggio.clifor.amministrativi.listino
          nr.valore = { ...nr.valore, ...this.locDocumento.appoggio.clifor.amministrativi.sconti }
          _.set(nr, 'appoggio.prodotto', p)
          _.set(nr, 'prodotto.codice', idProdotto)
          this.$emit('nuovaRiga', nr) // verificare se a questo livello o alla fine, dopo aver aggiunto il prodotto
          await this.$nextTick()
          const index = this.locDocumento.righe.length - 1
          let data = {
            model: 'prodotto.codice',
            subModel: null,
            value: p._id,
            item: p,
            index: index
          }
          await this.componentValueChange(data)
          data = {
            model: 'quantita',
            decimals: 2,
            subModel: null,
            value: riga.quantita,
            item: null,
            index: index
          }
          await this.componentValueChange(data)
        }
        await this.$nextTick()
        this.mostraParcheggio = false
        this.$emit('mostraParcheggio', false)
      },
      onMostraParcheggio() {
        this.mostraParcheggio = !this.mostraParcheggio
        this.$emit('mostraParcheggio', this.mostraParcheggio)
      },
      async menuClick({ command, index }) {
        switch(command) {
          case 'utility_storico':
            this.dialogStorico = true
            this.prodottoStorico = this.locDocumento.righe[index]
            await this.$nextTick()
            this.dialogStorico = false
            break
          case 'move_top':
            this.$emit('move', index, 0)
            break
          case 'move_bottom':
            this.$emit('move', index, -1)
            break
          case 'move_up':
            this.$emit('move', index, index - 1)
            break
          case 'move_down':
            this.$emit('move', index, index + 1)
            break
          default:
            break
        }
      },
      disableRigaDescrittiva(item) {
        const isProdotto = item.prodotto && item.prodotto.codice.length > 0 ? true : false
        const isQuantita = item.quantita && parseFloat(item.quantita) > 0 ? true : false
        return this.readOnly || isProdotto || isQuantita
      },      
      toggleLock() {
        this.aggiornaSconti = !this.aggiornaSconti
      },
      dialogClose () {
        this.dialog = false
        this.$nextTick(() => {
/*           this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1 */
        })
      },
      getSconto(item) {
        return +(parseFloat(item.valore.prezzoTotale) - parseFloat(item.valore.importoTotale)).toFixed(2)
      },
      getIva(item) {
        return +(parseFloat(item.valore.importoTotale) - parseFloat(item.valore.importoNettoTotale)).toFixed(2)
      },
      getPrezzoUnita(item, unita) {
        // ritorna il prezzo in base all'unità di misura selezionata
        // TODO: Gestire nel prodotto un array di valori con i corrispondenti fattori di conversione
        // Per adesso considero solo 2 prezzi (confezione/chilo e pezzo)
        const prezzoPezzo = _ .get(item, 'appoggio.prodotto.item.magazzino.prezzoAcquistoPezzo', 0)
        const prezzo = _.get(item, 'appoggio.prodotto.acquisto', 0)
        if (['pz', 'n'].includes(unita)) {
          return prezzoPezzo
        } else {
          return prezzo
        }
      },
      getUltimoAcquisto(item, fornitore) {
        // const prezzoPezzo = _ .get(item, 'appoggio.prodotto.item.magazzino.prezzoAcquistoPezzo', 0)
        if (fornitore) {
          // Ritorna il prezzo di acquisto dal fornitore scelto per l'ordine
          const fo = _.get(this.locDocumento, 'anagrafica.fornitore', null)
          const ff = _.get(item, 'appoggio.prodotto.item.fornitori', [])
          const f = fo && ff.find(x => x.codice === fo.codice)
/*           if (f) {
            return prezzoPezzo || f.prezzo || _.get(item, 'appoggio.prodotto.acquisto', 0)
          } else {
            return prezzoPezzo || _.get(item, 'appoggio.prodotto.acquisto', 0) || _.get(item, 'appoggio.prodotto.item.ultimoAcquisto.prezzo', '0')
          } */
          // TODO: Verificare il caso del fornitore se è presente l'unità di misura
          if (f) {
            return this.getPrezzoUnita(item, 'pz') || f.prezzo || this.getPrezzoUnita(item)
          } else {
            return this.getPrezzoUnita(item, item.unitaMisura && item.unitaMisura.codice) // prezzoPezzo || _.get(item, 'appoggio.prodotto.acquisto', 0) || _.get(item, 'appoggio.prodotto.item.ultimoAcquisto.prezzo', '0')
          }          
        } else {
          // Ritorna i dati dell'ultimo acquisto effettuato, anche se da fornitore diverso
          const ua = _.get(item, 'appoggio.prodotto.item.ultimoAcquisto', null)
          return _.get(ua,'fornitoreDescrizione', false) ? `${ua.fornitoreDescrizione} @ ${this.$options.filters.date(ua.data)} ( ${ua.quantita} : ${this.$options.filters.euro(this.getPrezzoUnita(item, item.unitaMisura && item.unitaMisura.codice) || ua.prezzo)} )` : '0'
          // return _.get(item, 'appoggio.prodotto.item.ultimoAcquisto.prezzo', '')
        }
      },
      getImportoTotale(item) {
        const pz = this.getUltimoAcquisto(item, true)
        const qta = item.quantita || _.get(item, 'ordine.ordinato') || 0
        // return item.costoTotale || (qta ? +(pz * qta).toFixed(2) : '0')
        return qta ? +(pz * qta).toFixed(2) : '0'
      },
      itemRigaDescrittiva(item) {
        return  {
          "model": "rigaDescrittiva",
          "valueField": "rigaDescrittiva",
          "type": "Switch",
          "label": "",
          value: _.get(item, 'rigaDescrittiva', false)
        }
      },
      itemCodice(item, onlyValue) {
        if (onlyValue) {
          return _.get(item, 'prodotto.codice', '')
        }        
        return {
          "model": "prodotto.codice",
          "valueField": "prodotto.codice",
          "label": "Codice Prodotto",
          "type": "Prodotto",
          "required": false,
          "hint": "prodotto.descrizione",
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          "cercaEsterno": true,
          "usaScalaTaglie": _.get(item, 'usaScalaTaglie', ''),
          value: _.get(item, 'prodotto.codice', '')          
        }
      },
      itemDescrizione(item) {
        return {
          "model": "descrizione",
          "valueField": "descrizione",
          "label": "Descrizione",
          "type": "TextArea",
          "required": true,
          value: _.get(item, 'descrizione', '') 
        }
      },
      itemQuantita(item) {
        return {
          "model": "quantita",
          "valueField": "quantita",
          "label": "Quantità",
          "type": "Testo",
          "required": !_.get(item, 'appoggio.rigaDescrittiva', false),
          "numerico": true,
          "decimals": 2,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'quantita', '') || _.get(item, 'ordine.ordinato', '') 
        }
      },
      itemUnitaMisura(item) {
        return {
          "model": "unitaMisura",
          "subModel": "codice", // TODO: ###03/10/2023 VERIFICARE
          "valueField": "unitaMisura",
          "type": "Multiselect",
          "label": "UM",
          "source": "prodotti_unita_misura.um",
          "required": true,
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'unitaMisura', '') 
        }
      },
      itemListino(item) {
        return {
          "model": "valore.listino",
          "valueField": "valore.listino",
          "type": "Multiselect",
          "label": "Listino",
          "source": "listini.listini",
          "required": true,
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'valore.listino', '') 
        }
      },
      itemAliquota(item, onlyValue) {
        if (onlyValue) {
          return  _.get(item, 'aliquotaIva.descrizione', '') 
        }   
        return {
          "model": "appoggio.aliquotaIva",
          "valueField": "appoggio.aliquotaIva",
          "type": "Multiselect",
          "label": "Aliquota Iva",
          "source": "prodotti_aliquote_iva.aliquote",
          "required": false,
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'aliquotaIva', '') 
        }
      },
      itemOmaggio(item) {
        return  {
          "model": "omaggio",
          "valueField": "omaggio",
          "type": "Switch",
          "label": "",
          value: _.get(item, 'omaggio', false)
        }
      },      
      itemPrezzi(item) {
        return {
          "label": "Prezzi",
          "model1": "valore.prezzoNettoUnitario",
          "valueField1": "valore.prezzoNettoUnitario",
          "label1": "netto unitario",
          "classTestCondition1": "appoggio.listino.nonIvato",
          "classIfCondition1": "font-weight-black",
          "model2": "valore.prezzoNettoTotale",
          "valueField2": "valore.prezzoNettoTotale",
          "label2": "netto totale",
          "classTestCondition2": "appoggio.listino.nonIvato",
          "classIfCondition2": "font-weight-black",
          "model3": "valore.prezzoUnitario",
          "valueField3": "valore.prezzoUnitario",
          "label3": "unitario",
          "classTestCondition3": "appoggio.listino.ivato",
          "classIfCondition3": "font-weight-black",
          "model4": "valore.prezzoTotale",
          "valueField4": "valore.prezzoTotale",
          "label4": "totale",
          "classTestCondition4": "appoggio.listino.ivato",
          "classIfCondition4": "font-weight-black",
          "type": "QuattroValori",
          "required": false,
          "numerico": true,
          "decimals": 2,
          value1: _.get(item, 'valore.prezzoNettoUnitario', ''),
          value2: _.get(item, 'valore.prezzoNettoTotale', ''),
          value3: _.get(item, 'valore.prezzoUnitario', ''),
          value4: _.get(item, 'valore.prezzoTotale', '')
        }
      },
      itemSconti(item) {
        return {
          "label": "Sconti",
          "model1": "valore.sconto1",
          "valueField1": "valore.sconto1",
          "label1": "sconto 1",
          "model2": "valore.sconto2",
          "valueField2": "valore.sconto2",
          "label2": "sconto 2",
          "model3": "valore.sconto3",
          "valueField3": "valore.sconto3",
          "label3": "sconto 3",
          "model4": "valore.sconto4",
          "valueField4": "valore.sconto4",
          "label4": "sconto 4",
          "type": "QuattroValori",
          "required": false,
          "numerico": true,
          "decimals": 2,
          value1: _.get(item, 'valore.sconto1', ''),
          value2: _.get(item, 'valore.sconto2', ''),
          value3: _.get(item, 'valore.sconto3', ''),
          value4: _.get(item, 'valore.sconto4', '')      
        }
      },
      itemImporti(item) {
        return       {
          "label": "Importi",
          "model1": "valore.importoNettoUnitario",
          "valueField1": "valore.importoNettoUnitario",
          "label1": "netto unitario",
          "model2": "valore.importoNettoTotale",
          "valueField2": "valore.importoNettoTotale",
          "label2": "netto totale",
          "model3": "valore.importoUnitario",
          "valueField3": "valore.importoUnitario",
          "label3": "unitario",
          "model4": "valore.importoTotale",
          "valueField4": "valore.importoTotale",
          "label4": "totale",
          "type": "QuattroValori",
          "required": false,
          "numerico": true,
          "decimals": 2,
          value1: _.get(item, 'valore.importoNettoUnitario', ''),
          value2: _.get(item, 'valore.importoNettoTotale', ''),
          value3: _.get(item, 'valore.importoUnitario', ''),
          value4: _.get(item, 'valore.importoTotale', '')
        }
      },
      getGiacenza(item) {
        return _.get(item, 'appoggio.prodotto.item.magazzino.giacenza', 0)
      },
      rigaSconti(v) {
        const sc = []
        v.sconto1 && sc.push (v.sconto1)
        v.sconto2 && sc.push (v.sconto2)
        v.sconto3 && sc.push (v.sconto3)
        v.sconto4 && sc.push (v.sconto4)
        return sc.join('+')
      },
      async onNuovaRiga() {
        const nr = JSON.parse(JSON.stringify(this.rigaModello))
        nr.valore = nr.valore || {}
        nr.valore.listino = this.locDocumento.appoggio.clifor.amministrativi.listino
        nr.valore = { ...nr.valore, ...this.locDocumento.appoggio.clifor.amministrativi.sconti }
        this.$emit('nuovaRiga', nr)
      },
      async onNuovaRigaST() {
        const nr = JSON.parse(JSON.stringify(this.rigaModello))
        nr.valore = nr.valore || {}
        nr.valore.listino = this.locDocumento.appoggio.clifor.amministrativi.listino
        nr.valore = { ...nr.valore, ...this.locDocumento.appoggio.clifor.amministrativi.sconti }
        nr.usaScalaTaglie = true
        this.$emit('nuovaRiga', nr)
      },      
      async editItem (item) {
/*         this.editedIndex = this.righeDocumento.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.completaAppoggio()
        this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
      duplicateItem(item) {
/*         this.editedIndex = -1
        this.editedItem = Object.assign({}, item)
        this.editedItem._id = ''
        delete this.editedItem._rev
        this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
      deleteItem (item) {
        this.editedIndex = this.righeDocumento.indexOf(item)
        this.dialogDelete = true
/*         this.editedIndex = this.righeDocumento.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true */
      },
      async deleteItemConfirm () {
       // TODO: Verificare se necessario cancellare il movimento
        const riga = this.righeDocumento[this.editedIndex]
        const documento = this.locDocumento
        await magazzino.cancellaRigaPerRiferimento('documento', documento.codice, documento.data, riga.codice)   
        
        this.righeDocumento.splice(this.editedIndex, 1)
        this.forzaAggiornamento = true
        this.closeDelete()
        this.editedIndex = -1
        this.$emit('updateTotali')
        await this.$nextTick()
        this.forzaAggiornamento = false
        this.$emit('salvaDocumento')
      },

      close () {
        this.dialog = false
/*         this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, null)
          this.editedIndex = -1
        }) */
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          // this.editedItem = Object.assign({}, null)
          this.editedIndex = -1
        })
      },
      async save () {
/*         this.$store.commit('documentiDettaglio/CLEAR_RIGA_DOCUMENTO_SAVED')
        this.editedItem = this.$store.getters['documentiDettaglio/rigaDocumento']
        let documento = await documenti.getDocumento(this.chiaveDocumento._id)
        if (this.editedIndex > -1) {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)        
          Object.assign(this.righeDocumento[this.editedIndex], this.editedItem)
          Object.assign(documento.righe[this.editedIndex], this.editedItem)
        } else {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)        
          this.righeDocumento.push(this.editedItem)
          documento.righe = documento.righe || []
          documento.righe.push(this.editedItem)
        }
        if (!await documenti.aggiornaDocumento(documento)) {
          this.dialogErrore = true
          return
        }
        this.close()
        this.$store.commit('documentiDettaglio/CLEAR_RIGA_DOCUMENTO')
        await this.getDataFromApi() */
      },      
      erroreConfirm() {
        this.dialogErrore = false
        this.erroreDocumento = ''
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
/*         const item = options.item
        this.editedIndex = this.righeDocumento.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', true)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
/*       datiVisualizzazione(documenti) {
        const elaborati = documenti.map(el => {
         // const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)
          const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)
          return { ...el, c_nominativo: nominativo }
        }) 
        return elaborati
      },
      deleteDatiVisualizzazione(documento) {
        let locDocumento = {...documento}
        delete locDocumento.c_nominativo
        delete locDocumento.appoggio
        return locDocumento
      }, */
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      },
      aggiornaPrezzo({ listino, valore, codice }) {
        // this.refreshSource++
        this.forzaAggiornamento = false
        this.refreshSourceCode = codice
        this.refreshSource++
      },
      async componentValueChange(data) {
        const { model, subModel, value, decimals, index } = data
        this.locRigaDocumento = this.righeDocumento[index]
        let tgt = {}
        if (subModel) {
          let vv = value[subModel]
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        } else {
          let vv = value
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        }
        _.merge(this.locRigaDocumento, tgt)
        await this.aggiornaCorrelati(data)
        // this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.locRigaDocumento) // verificare se va fatta store_temp
      },
      async aggiornaCorrelati(data) {
        this.locRigaDocumento.appoggio = this.locRigaDocumento.appoggio || {}
        let tipoModifica = ''
        switch (data.model) {
          case 'prodotto.codice':
            if (!data.value) {
              delete this.locRigaDocumento.appoggio.prodotto
              delete this.locRigaDocumento.prodotto
              _.set(this.locRigaDocumento, 'valore.prezzoUnitario', 0)   
              this.locRigaDocumento.descrizione = ''
            } else {
              if (!this.locRigaDocumento.codiceRiga) {
                this.locRigaDocumento.codiceRiga = uuidv4()
                if (this.locRigaDocumento.usaScalaTaglie) {
                  this.locRigaDocumento.scalaTaglie = _.get(data.item, 'item.custom.scalaTaglie')
                  // console.log(this.locRigaDocumento)
                  this.expanded = [this.locRigaDocumento]
                }
              }              
              this.locRigaDocumento.appoggio.prodotto = data.item
              if (this.locRigaDocumento.usaScalaTaglie) {
                this.locRigaDocumento.descrizione = data.item.descrizione
              } else {              
                this.locRigaDocumento.descrizione = `${data.item.descrizione} ${_.get(data.item, 'variante2.descrizione', '')} ${_.get(data.item, 'variante1.descrizione', '')}`.trim()
              }
              if (this.locRigaDocumento.appoggio.importiModificati) { // La prima volta, devo rileggere il prodotto ma non impostare il listino. Se cambio prodotto, si
                this.locRigaDocumento.appoggio.importiModificati = false
                this.updateTrigger++
                return
              }
              this.locRigaDocumento.tipoBene = data.item.tipoBene || data.item.item.tipoBene
              this.locRigaDocumento.repartoFiscale = data.item.datiFiscali.reparto.stampante
              
              let um = _.get(this, 'locRigaDocumento.unitaMisura', '') || _.get(data.item, 'magazzino.unitaMisura', '') || _.get(data.item, 'item.magazzino.unitaMisura', '') || _.get(data.item, 'item.magazzino.um', '')
              this.locRigaDocumento.unitaMisura = um
              
              this.locRigaDocumento.aliquotaIva = data.item.datiFiscali.aliquoteIva[0]
              await this.$nextTick()
              const ref = this.$refs[`quantita_${data.index}`]
              const input = ref.$el.querySelector('input:not([type=hidden]),textarea:not([type=hidden])')
              if (input) {
                setTimeout(() => {
                  input.focus()
                }, 0)
              }
            }
            break;
          case 'rigaDescrittiva':
            delete this.locRigaDocumento.appoggio.prodotto
            delete this.locRigaDocumento.prodotto
            _.set(this.locRigaDocumento, 'valore.prezzoUnitario', 0)
            _.set(this.locRigaDocumento, 'appoggio.rigaDescrittiva', data.value)       
            this.locRigaDocumento.descrizione = ''
            break;
          case 'valore.listino':
            _.set(this.locRigaDocumento,'appoggio.listino.ivato', _.get(data,'value.ivato', true))
            _.set(this.locRigaDocumento,'appoggio.listino.nonIvato', !_.get(data,'value.ivato', true))
            tipoModifica = data.model
            break;
          case 'valore.sconto1':
          case 'valore.sconto2':
          case 'valore.sconto3':
          case 'valore.sconto4':
            this.locRigaDocumento.sconti = this.rigaSconti(this.locRigaDocumento.valore)
            this.aggiornaImportoUnitarioOrdine()
            tipoModifica = data.model
            break;
          case 'valore.prezzoUnitario':          
          case 'valore.prezzoTotale':
          case 'valore.prezzoNettoUnitario':
          case 'valore.prezzoNettoTotale':
          case 'valore.importoUnitario':
          case 'valore.importoTotale':
          case 'valore.importoNettoUnitario':
          case 'valore.importoNettoTotale':
            tipoModifica = data.model
            this.locRigaDocumento.valore.importiModificati = true // viene messo su appoggio alla successiva riapertura della riga
            break;        
          case 'appoggio.aliquotaIva':
            this.locRigaDocumento.aliquotaIva = this.locRigaDocumento.appoggio.aliquotaIva
            this.locRigaDocumento.aliquotaIva.valore = this.locRigaDocumento.aliquotaIva.aliquota
            tipoModifica = data.model
            break;
          case 'quantita':       
            this.aggiornaImportoUnitarioOrdine()
            tipoModifica = data.model   
            break;
          default:
            break
        }
        this.aggiornaValori(tipoModifica)
        this.updateTrigger++
        this.$emit('updateTotali')
      },
/*       rigaSconti(v) {
        const sc = []
        v.sconto1 && sc.push (v.sconto1)
        v.sconto2 && sc.push (v.sconto2)
        v.sconto3 && sc.push (v.sconto3)
        v.sconto4 && sc.push (v.sconto4)
        return sc.join('+')
      }, */
      round2Dec(value) {
        const fattore = Math.pow(10, this.numDecimali)
        return Math.round( value * fattore + Number.EPSILON ) / fattore
      },
      aggiornaImportoUnitarioOrdine() {
        let sc1 = parseFloat(_.get(this.locRigaDocumento,'ordine.sconto1', 0) || '0')
        let sc2 = parseFloat(_.get(this.locRigaDocumento,'ordine.sconto2', 0) || '0')
        let sc3 = parseFloat(_.get(this.locRigaDocumento,'ordine.sconto3', 0) || '0')
        let sc4 = parseFloat(_.get(this.locRigaDocumento,'ordine.sconto4', 0) || '0')
        let sconto = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)
        this.isSconto = sc1 + sc2 + sc3 + sc4
        // const pz = _.get(this.locRigaDocumento,'ordine.prezzo', _.get(this.locRigaDocumento,'valore.acquisto', 0))
        const um = _.get(this.locRigaDocumento, 'unitaMisura.codice', '') || _.get(this.locRigaDocumento, 'unitaMisura','')
        // const pz = _.get(this.locRigaDocumento,'ordine.prezzo', this.getPrezzoUnita(this.locRigaDocumento, um, 0))
        let pz = _.get(this.locRigaDocumento,'ordine.prezzo') || _.get(this.locRigaDocumento,'ordine.prezzoUnitario') || this.getPrezzoUnita(this.locRigaDocumento, um, 0) || 0
        if (sconto === 0 && this.isSconto) { // Nel caso di sconto 100% il valore di "sconto" viene = 0
          pz = 0
        }
        this.locRigaDocumento.ordine = this.locRigaDocumento.ordine || {}
        this.locRigaDocumento.ordine.prezzoUnitario = pz * sconto
      },      
      aggiornaValori(tipoModifica) {
        const rd = _.get(this.locRigaDocumento,'appoggio.rigaDescrittiva', false)
        const prd = _.get(this.locRigaDocumento,'appoggio.prodotto', {})
        const lst = _.get(this.locRigaDocumento,'valore.listino.codice', '')
        const ivato = rd ? true : _.get(this.locRigaDocumento,'valore.listino.ivato', true) // Verificare come gestire se riga descrittiva
        let pl = rd ? parseFloat(_.get(this.locRigaDocumento,'valore.prezzoUnitario', 0)) : parseFloat(_.get(prd, `prezzoItem.${lst}.base`, 0)) || parseFloat((ivato ? _.get(this.locRigaDocumento, `valore.importoUnitario`, 0) : _.get(this.locRigaDocumento, `valore.importoNettoUnitario`, 0)))
        const qta = parseFloat(_.get(this.locRigaDocumento,'quantita', 0))
        let sc1 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto1', 0) || '0')
        let sc2 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto2', 0) || '0')
        let sc3 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto3', 0) || '0')
        let sc4 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto4', 0) || '0')
        let sconto = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)
        // const iva = _.get(prd,'datiFiscali.aliquoteIva[0]', {})
/*    
        const iva = _.get(this.locRigaDocumento,'aliquotaIva.valore', {})
        if (!this.locRigaDocumento.aliquotaIva) { // Modifico solo se non ho l'aliquota forzata dal cliente
          this.locRigaDocumento.aliquotaIva = iva
        } */
        const aliquota = rd ? '' : (this.locRigaDocumento.aliquotaIva && (this.locRigaDocumento.aliquotaIva.valore || this.locRigaDocumento.aliquotaIva.aliquota)) || 0
        let aggiornaSconti = this.aggiornaSconti
        if (parseFloat(this.locRigaDocumento.valore.prezzoUnitario || 0) === 0) {
          // Se prezzo di listino nullo (es reparto o prezzi non inseriti) --> aggiornaSconti = false !!
          aggiornaSconti = false
        }

        this.locRigaDocumento.valore.acquisto = this.locRigaDocumento.valore.acquisto || _.get(this.locRigaDocumento, 'appoggio.prodotto.acquisto', 0)
        if (ivato) {
          switch (tipoModifica) {
            case 'valore.prezzoUnitario':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario)
              break;
            case 'valore.prezzoTotale':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoTotale) / qta
              break;
            case 'valore.prezzoNettoUnitario':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario) * ( 1 + aliquota / 100)
              break;
            case 'valore.prezzoNettoTotale':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoTotale) * ( 1 + aliquota / 100) / qta
              break;
            case 'valore.importoUnitario':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoUnitario) / oldPl
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoUnitario) / sconto
              } else {
                pl = parseFloat(this.locRigaDocumento.valore.importoUnitario) / sconto
              }
              break;
            case 'valore.importoTotale':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoUnitario || 0)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoTotale) / (oldPl * qta)
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / (sconto * qta)
              } else {
                pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / (sconto * qta)
              }
              break;
            case 'valore.importoNettoUnitario':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / oldPl
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / sconto
              } else {
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / sconto
              }
              break;
            case 'valore.importoNettoTotale':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (oldPl * qta)
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (sconto * qta)
              } else {
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (sconto * qta)
              }
              break; 
            case 'valore.sconto1':
            case 'valore.sconto2':
            case 'valore.sconto3':
            case 'valore.sconto4':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario) || pl
              break;
            default:
              // pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario) || pl
              break;
          }

          if (tipoModifica) {
            this.locRigaDocumento.valore.prezzoUnitario = pl ? this.round2Dec(pl) : 0
            this.locRigaDocumento.valore.prezzoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.prezzoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.prezzoNettoUnitario = pl ? this.round2Dec(pl / ( 1 + aliquota / 100)): 0
            this.locRigaDocumento.valore.prezzoNettoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.prezzoUnitario = pl ? +this.locRigaDocumento.valore.prezzoUnitario.toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.prezzoNettoUnitario = pl ? +this.locRigaDocumento.valore.prezzoNettoUnitario.toFixed(this.numDecimali) : 0

            this.locRigaDocumento.valore.importoUnitario = pl ? this.round2Dec(pl * sconto) : 0
            this.locRigaDocumento.valore.importoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.importoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.importoNettoUnitario = pl ? this.round2Dec((pl / ( 1 + aliquota / 100)) * sconto) : 0
            this.locRigaDocumento.valore.importoNettoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.importoNettoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.importoUnitario = pl ? +this.locRigaDocumento.valore.importoUnitario.toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.importoNettoUnitario = pl ? +this.locRigaDocumento.valore.importoNettoUnitario.toFixed(this.numDecimali) : 0
          }
        } else {
        switch (tipoModifica) {
            case 'valore.prezzoUnitario':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario) / ( 1 + aliquota / 100)
              break;
            case 'valore.prezzoTotale':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoTotale) / ( 1 + aliquota / 100) / qta
              break;
            case 'valore.prezzoNettoUnitario':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
              break;
            case 'valore.prezzoNettoTotale':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoTotale) / qta
              break;
            case 'valore.importoUnitario':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoUnitario) / ( 1 + aliquota / 100) / oldPl
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoUnitario) / ( 1 + aliquota / 100) / sconto
              } else {
                // pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario) / sconto
                pl = parseFloat(this.locRigaDocumento.valore.importoUnitario) / ( 1 + aliquota / 100) / sconto
              }
              break;
            case 'valore.importoTotale':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoTotale) / ( 1 + aliquota / 100) / (oldPl * qta)
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / ( 1 + aliquota / 100) / (sconto * qta)
              } else {
                // pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / (sconto * qta)
                pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / ( 1 + aliquota / 100) / (sconto * qta)
              }
              break;
            case 'valore.importoNettoUnitario':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) / oldPl
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) / sconto
              } else {
                // pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / sconto
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) / sconto
              }
              break;
            case 'valore.importoNettoTotale':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) / (oldPl * qta)
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) / (sconto * qta)
              } else {
                // pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (sconto * qta)
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) / (sconto * qta)
              }
              break;
            case 'valore.sconto1':
            case 'valore.sconto2':
            case 'valore.sconto3':
            case 'valore.sconto4':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario) || pl
              break;
            default:
              // pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario) || pl
              break;
          }
          if (tipoModifica) {
            this.locRigaDocumento.valore.prezzoNettoUnitario = pl ? this.round2Dec(pl) : 0
            this.locRigaDocumento.valore.prezzoNettoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.prezzoUnitario = pl ? this.round2Dec(pl * ( 1 + aliquota / 100)) : 0
            this.locRigaDocumento.valore.prezzoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.prezzoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.prezzoNettoUnitario = pl ? +this.locRigaDocumento.valore.prezzoNettoUnitario.toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.prezzoUnitario = pl ? +this.locRigaDocumento.valore.prezzoUnitario.toFixed(this.numDecimali) : 0
            
            this.locRigaDocumento.valore.importoNettoUnitario = pl ? this.round2Dec(pl * sconto) : 0
            this.locRigaDocumento.valore.importoNettoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.importoNettoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.importoUnitario = pl ? this.round2Dec((pl * ( 1 + aliquota / 100)) * sconto) : 0
            this.locRigaDocumento.valore.importoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.importoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.importoNettoUnitario = pl ? +this.locRigaDocumento.valore.importoNettoUnitario.toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.importoUnitario = pl ? +this.locRigaDocumento.valore.importoUnitario.toFixed(this.numDecimali) : 0            
          }
        }
      },
      rielaboraSconti(oldSc, sconto) {
        let sc1 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto1', 0) || '0')
        let sc2 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto2', 0) || '0')
        let sc3 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto3', 0) || '0')
        let sc4 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto4', 0) || '0')

        let newSc = 1
        if (sconto < oldSc) {
          sc4 = (1 - sconto/ ((1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100))) * 100
          _.set(this.locRigaDocumento,'valore.sconto4', sc4.toFixed(this.numDecimali))
        } else {
          if (sc4) {
            sc4 = (1 - sconto/ ((1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100))) * 100
            if (sc4 < 0) sc4 = 0
              _.set(this.locRigaDocumento,'valore.sconto4', sc4.toFixed(this.numDecimali))
          }
          newSc = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)
          if (newSc < sconto && sc3) {
            sc3 = (1 - sconto / ((1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc4 / 100))) * 100
            if (sc3 < 0) sc3 = 0
              _.set(this.locRigaDocumento,'valore.sconto3', sc3.toFixed(this.numDecimali))
          }
          newSc = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)
          if (newSc < sconto && sc2) {
            sc2 = (1 - sconto / ((1 - sc1 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100))) * 100
            if (sc2 < 0) sc2 = 0
              _.set(this.locRigaDocumento,'valore.sconto2', sc2.toFixed(this.numDecimali))
          }
          newSc = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)                
          if (newSc < sconto && sc1) {
            sc1 = (1 - sconto / ((1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100))) * 100
            // if (sc1 < 0) sc1 = 0 // Non cancello, se minore di zero è una Maggiorazione
              _.set(this.locRigaDocumento,'valore.sconto1', sc1.toFixed(this.numDecimali))
          }
        }
      },
      async salvaDatiST(item, payload) {
        let qtaTotale = 0
        let przTotale = 0
        let elencoProdotti = []
        for (let c of payload.scala.colori) {
          let valori = payload.valori[c.codice]
          for (let t of payload.scala.taglie) {
            if (!valori[String(t.codice)]) {
              continue
            }
            const valore = +parseFloat(valori[t.codice] || 0).toFixed(2)
            qtaTotale += valore
            const id = prodotti.creaCampoRicercaTC_Codici(item.prodotto.codice, t.codice, c.codice)
            let prodotto = await prodotti.getProdotto(id)
            const listino = _.get(item, 'valore.listino.codice', 'L1')
            let prezzoUn = _.get(prodotto, 'prezzo.' + listino + '.base', 0)
            const pzTot = prezzoUn * valore
            przTotale += pzTot
            elencoProdotti.push({
              id: id,
              //taglia: t.codice,
              taglia: t,
              // tagliaDescrizione: t.descrizione,
              // colore: c.codice,
              colore: c,
              // coloreDescrizione: c.descrizione,
              quantita: valore,
              prezzo: pzTot
            })
/*             let prodotto = await prodotti.getProdotto(id)
            if (!prodotto) {
              continue
            } */
          }
        }
        item.scalaTaglie.elencoProdotti = elencoProdotti
        item.quantita = qtaTotale
        item.valore.prezzoTotale = przTotale
        item.valore.prezzoUnitario = +(przTotale / qtaTotale).toFixed(2)
        this.aggiornaValori('valore.prezzoUnitario')
        this.updateTrigger++
        this.$emit('updateTotali')        
      }      
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
    td.articoliSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }

  .bodyTable .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding: 0;
  }

  .is-omaggio {
    background-color: #DCEDC8;
  }  
</style>
